export default __webpack_public_path__ + "static/media/littlebobo.70730fd7.jpg";